import Analytics from '@components/charts/analytics/Analytics'
import { appConnectorNames } from '@components/connectors/Summary'
import Page from '@components/Page/Page'
import { AnalyticsProvider } from '@contexts/AnalyticsContext'
import { useAppSelector } from '@store/hooks'
import { selectSelectedVenue } from '@store/VenueReducer'
import { Col, Spin } from 'antd'
import { FC } from 'react'
import ConversionSection from './ConversionSection'
import ImpressionSection from './ImpressionSection'
import RevenueSpendsSection from './RevenueSpendsSection'

const OverviewTab: FC = () => {
  const venue = useAppSelector(selectSelectedVenue())

  if (!venue) {
    return <Spin />
  }

  // The gate lives here, not inside ConversionSection / RevenueSpendsSection:
  // the global pages reuse them (ConversionPage renders ConversionSection
  // itself, RevenuePage renders the same SpendPerDay / SpendPerPartySize
  // charts) and every one of those reads selectSelectedVenue() on its own, so
  // gating down there would blank the global pages whenever a venue is still
  // selected in the store. This tab is the only place that knows it is looking
  // at exactly one venue.
  const hasReservationAnalytics =
    venue.booking.analytics?.reservations !== false

  const activeConnector = venue.booking.app.activeConnector
  const unavailableReason = activeConnector
    ? `Bookings for this venue go through ${appConnectorNames[activeConnector]}, so no reservation is recorded in Pléthore.`
    : 'This venue has no booking connector configured, so no reservation is recorded in Pléthore.'

  return (
    <AnalyticsProvider>
      <Page rowGutter={[32, 32]} noWrapWithCol>
        <Col span={24}>
          <ImpressionSection />
        </Col>
        <Col span={24}>
          {hasReservationAnalytics ? (
            <ConversionSection />
          ) : (
            <Analytics.Unavailable
              title="Reservation conversion"
              reason={unavailableReason}
            />
          )}
        </Col>
        <Col span={24}>
          {hasReservationAnalytics ? (
            <RevenueSpendsSection />
          ) : (
            <Analytics.Unavailable
              title="Revenue & spends"
              reason={unavailableReason}
            />
          )}
        </Col>
      </Page>
    </AnalyticsProvider>
  )
}

export default OverviewTab
